import(/* webpackMode: "eager", webpackExports: ["TermView"] */ "/web/src/sections/policy/term/view/term-view.tsx");
